import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  Modal,
  Button,
  Spinner,
  Row,
  Col,
  Nav,
  Dropdown,
  Form,
} from "react-bootstrap";
import Block from "../../components/Block/Block";
import DataTableComponent from "../../components/DataTable/DataTable";
import DataTable from "../../components/DataTable/DataTable";

import "../../assets/scss/main.scss";
import Layout from "../../layout/default";
import {
  CustomDropdownMenu,
  CustomDropdownToggle,
  Icon,
  LinkList,
  LinkListItem,
} from "../../components";
import Swal from "sweetalert2";
import instance from "../api";
import { createPortal } from "react-dom";
import { set } from "date-fns";
// const getStatusStyle = (status) => {
//   switch (status) {
//     case 'Pending':
//       return { color: "#ff9800", backgroundColor: "#fff3e0", padding: "0.375rem 0.75rem", borderRadius: "0.25rem" };
//     case 'Processing':
//       return { color: "#ff5722", backgroundColor: "#ffebee", padding: "0.375rem 0.75rem", borderRadius: "0.25rem" };
//     case 'Complete':
//     case 'Shipped':
//       return { color: "#2dc58c", backgroundColor: "#e6f8f1", padding: "0.375rem 0.75rem", borderRadius: "0.25rem" };
//     default:
//       return { color: "#c54b2d", backgroundColor: "#f8e9e6", padding: "0.375rem 0.75rem", borderRadius: "0.25rem" };
//   }
// };
const OrderList = ({ title }) => {
  useLayoutEffect(() => {
    document.title = `${title} - Swagruha Foods`;
  }, [title]);

  const [searchText, setSearchText] = useState("");
  const [filterWhatsApp, setFilterWhatsApp] = useState(false);

  const [ordersData, setOrdersData] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  useEffect(() => {
    const fetchStatusList = async () => {
      try {
        const response = await instance.get("api/Master/OrderStatus");
        if (response.status === 200) {
          const filteredStatus = response.data.rows.filter((status) =>
            [
              "Pending",
              "Processing",
              "Shipped",
              "Complete",
              "Canceled",
              "Failed",
              "Refunded",
            ].includes(status.name)
          );
          setStatusList(filteredStatus);
          setSelectedStatus(filteredStatus[0].order_status_id);
        }
      } catch (error) {
        console.error("Error fetching status list:", error);
      }
    };
    fetchStatusList();
  }, []);

  const fetchOrders = async (page, pageSize, status) => {
    try {
      const params = { page, pageSize };
      if (status) {
        params.order_status_id = status;
      }

      if (searchText) {
        params.search = searchText;
      }

      if (filterWhatsApp) {
        params.from_wa = true;
      }

      const response = await instance.get("api/Order", { params });

      console.log(response.data);

      setOrdersData(response.data.orders.rows);
      setTotalRows(response.data.orders.count);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedStatus) {
      fetchOrders(page, pageSize, selectedStatus);
    }
  }, [page, pageSize, selectedStatus, searchText, filterWhatsApp]);

  const handleSearchTextChange = (text) => {
    setSearchText(text);
  };

  const handleRowsPerPageChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setPage(0);
  };

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleShowModal = async (orderId) => {
    setLoading(true);
    try {
      const response = await instance.get(`api/Order/${orderId}`);
      if (response.status === 200) {
        setSelectedOrder(response.data);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  const formatPrice = (price) => {
    const formattedPrice = parseFloat(price).toFixed(2).replace(/\.00$/, "");
    if (selectedOrder && selectedOrder.currency === "USD") {
      return `$${formattedPrice}`;
    }
    return `Rs.${formattedPrice}`;
  };

  const formattedPrice = (row) => {
    const formattedPrice = parseFloat(row.total)
      .toFixed(2)
      .replace(/\.00$/, "");
    if (row.currency === "USD") {
      return `$${formattedPrice}`;
    }
    return `Rs.${formattedPrice}`;
  };

  const updateOrderStatus = async (orderId, newStatusId) => {
    setLoading(true);
    try {
      const response = await instance.put(`api/Order/update/${orderId}`, {
        order_status_id: newStatusId,
      });
      fetchOrders(page, pageSize, selectedStatus);
      Swal.fire("Success", "Order status updated successfully!", "success");
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "Failed to update order status!", "error");
    } finally {
      setLoading(false);
    }
  };

  const viewInvoice = async (orderId) => {
    setLoading(true);
    try {
      const response = await instance.get(`api/Order/invoice/${orderId}`, {
        responseType: "blob",
      });
      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(fileURL, "_blank");
    } catch (error) {
      console.error("Error viewing invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  const downloadInvoice = async (orderId) => {
    setLoading(true);
    try {
      const response = await instance.get(`api/Order/invoice/${orderId}`, {
        responseType: "blob",
      });
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `invoice_${orderId}.pdf`);
      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);
    } catch (error) {
      console.error("Error downloading invoice:", error);
    } finally {
      setLoading(false);
    }
  };

  const getNextStatus = (statusName) => {
    const currentIndex = statusList.findIndex(
      (status) => status.name === statusName
    );
    return statusList[currentIndex + 1] || null;
  };

  const columns = [
    {
      name: "Order ID",
      selector: (row) => row.order_id,
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span
            onClick={() => viewInvoice(row.order_id)}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
          >
            {row.order_id}
          </span>
          {row.from_wa && (
            <span
              style={{
                color: "#25D366",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Icon name="whatsapp" />
            </span>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Order Date",
      selector: (row) => row.date_added,
      cell: (row) => <span>{new Date(row.date_added).toDateString()}</span>,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Customer",
      selector: (row) => row,
      cell: (row) => (
        <span>
          {row.firstname} {row.lastname}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Ordered Items",
      selector: (row) => row.OrderItems,
      cell: (row) => (
        <Button variant="link" onClick={() => handleShowModal(row.order_id)}>
          View Items
        </Button>
      ),
      sortable: true,
      minWidth: "200px",
    },
    {
      name: "Total Amount",
      selector: (row) => row.total,
      cell: (row) => <span>{formattedPrice(row)}</span>,
      sortable: true,
    },
    {
      name: "Order Status",
      selector: (row) => row.WebtagOrderStatus.name,
      cell: (row) => {
        // Function to generate class name based on the status
        const getStatusClassName = (status) =>
          `orderstatus-dropdown ${status.toLowerCase().replace(/\s+/g, "-")}`;

        return (
          <Dropdown>
            <Dropdown.Toggle
              variant="outline-secondary"
              size="sm"
              id={`dropdown-button-drop-${row.order_id}`}
              className={getStatusClassName(row.WebtagOrderStatus.name)}
            >
              {row.WebtagOrderStatus.name}
            </Dropdown.Toggle>
            {createPortal(
              <Dropdown.Menu>
                {statusList
                  .filter(
                    (status) =>
                      status.order_status_id !==
                      row.WebtagOrderStatus.order_status_id
                  )
                  .map((status) => (
                    <Dropdown.Item
                      key={status.order_status_id}
                      onClick={() =>
                        updateOrderStatus(row.order_id, status.order_status_id)
                      }
                      className={getStatusClassName(status.name)}
                    >
                      {status.name}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>,
              document.body
            )}
          </Dropdown>
        );
      },
      sortable: true,
    },

    {
      name: "Action",
      cell: (row) => {
        const nextStatus = getNextStatus(row.WebtagOrderStatus.name);
        const actions = [
          nextStatus &&
            nextStatus.name !== "Canceled" &&
            nextStatus.name !== "Failed" &&
            nextStatus.name !== "Refunded" && (
              <LinkListItem
                key="update"
                to="#"
                onClick={() =>
                  updateOrderStatus(row.order_id, nextStatus.order_status_id)
                }
              >
                <Icon name="edit"></Icon>
                <span>{nextStatus.name}</span>
              </LinkListItem>
            ),
          <LinkListItem
            key="view"
            to="#"
            onClick={() => viewInvoice(row.order_id)}
          >
            <Icon name="file-text"></Icon>
            <span>View Invoice</span>
          </LinkListItem>,
          <LinkListItem
            key="download"
            to="#"
            onClick={() => downloadInvoice(row.order_id)}
          >
            <Icon name="download"></Icon>
            <span>Download Invoice</span>
          </LinkListItem>,
        ].filter(Boolean);

        return (
          <div className="text-end w-100">
            <Dropdown>
              <Dropdown.Toggle
                size="sm"
                as={CustomDropdownToggle}
                className="btn btn-sm btn-icon btn-zoom me-n1"
              >
                <Icon name="more-v"></Icon>
              </Dropdown.Toggle>
              {createPortal(
                <Dropdown.Menu
                  className="dropdown-menu-sm"
                  as={CustomDropdownMenu}
                  align="end"
                >
                  <div className="dropdown-content py-1">
                    <LinkList className="link-list-hover-bg-primary link-list-md">
                      {actions}
                    </LinkList>
                  </div>
                </Dropdown.Menu>,
                document.body
              )}
            </Dropdown>
          </div>
        );
      },
      sortable: false,
    },
  ];

  return (
    <>
      <Layout title="Orders List" content="container">
        <Block.Head>
          <Block.HeadBetween>
            <Block.HeadContent>
              <Block.Title tag="h2">Orders List</Block.Title>
            </Block.HeadContent>
            <Block.HeadContent>
              <Form.Check
                type="switch"
                id="whatsapp-filter"
                label={
                  <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Icon name="whatsapp" style={{ color: "#25D366" }} />
                    WhatsApp Orders
                  </span>
                }
                checked={filterWhatsApp}
                onChange={(e) => {
                  setFilterWhatsApp(e.target.checked);
                  setPage(0);
                }}
                style={{ fontSize: "16px" }}
              />
            </Block.HeadContent>
          </Block.HeadBetween>
        </Block.Head>

        <Nav
          variant="tabs"
          activeKey={selectedStatus}
          onSelect={(status) => setSelectedStatus(status)}
        >
          {statusList.map((status) => (
            <Nav.Item key={status.order_status_id}>
              <Nav.Link eventKey={status.order_status_id}>
                {status.name}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <Block>
            <Card>
              <DataTable
                tableClassName="data-table-head-light table-responsive"
                data={ordersData}
                columns={columns}
                searchList={["firstname", "lastname"]}
                searchTerm="customer name, order id, phone or pincode"
                totalCount={totalRows}
                page={page}
                rowsPerPage={pageSize}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleRowsPerPageChange}
                onSearchTextChange={handleSearchTextChange}
              />
            </Card>
          </Block>
        )}
      </Layout>

      {selectedOrder && (
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Order Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>
              <strong>Ordered Products</strong>
            </h5>
            <Row style={{ maxHeight: "400px", overflowY: "auto" }}>
              {selectedOrder.WebtagOrderProducts.map((item, index) => (
                <Col key={index} sm={6} md={4} lg={4} className="mb-3">
                  <Card>
                    <Card.Body>
                      <Card.Title>
                        {item.name} - {formatPrice(item.price)}
                      </Card.Title>
                      <Card.Text>
                        {item.quantity} x {formatPrice(item.price)} ={" "}
                        {formatPrice(item.total)}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            <Row className="mt-3">
              <Col md={6}>
                <Card className="mb-3">
                  <Card.Body>
                    <Card.Title>User Details</Card.Title>
                    <Card.Text>
                     {selectedOrder.firstname}{" "}
                      {selectedOrder.lastname}
                      <br />
                      {selectedOrder.email}
                      <br />
                      {selectedOrder.telephone}
                      <br />
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="mb-3">
                  <Card.Body>
                    <Card.Title>Payment Details</Card.Title>
                    <Card.Text>
                      <strong>Payment Method:</strong>{" "}
                      {selectedOrder.payment_method}
                      <br />
                      <strong>Total Amount:</strong>{" "}
                      {formatPrice(selectedOrder.total)}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={6}>
                <Card className="mb-3">
                  <Card.Body>
                    <Card.Title>Billing Address</Card.Title>
                    <Card.Text>
                    {selectedOrder.payment_firstname}{" "}
                      {selectedOrder.payment_lastname}
                      <br />
                      {selectedOrder.payment_address_1}
                      <br />
                      {selectedOrder.payment_city},{" "}{selectedOrder.payment_zone},{" "}{selectedOrder.payment_postcode}{" "}
                      <br />
                   
                      {selectedOrder.payment_country}
                      <br />
                      {selectedOrder.payment_telephone ?  selectedOrder.payment_telephone : selectedOrder.telephone}
                      <br />

                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="mb-3">
                  <Card.Body>
                    <Card.Title>Shipping Address</Card.Title>
                    <Card.Text>
                      {selectedOrder.shipping_firstname}{" "}
                      {selectedOrder.shipping_lastname}
                      <br />
                      {selectedOrder.shipping_address_1}
                      <br />
                      {selectedOrder.shipping_city},{" "}{selectedOrder.shipping_zone},{" "}{selectedOrder.shipping_postcode}{" "}
                      <br />
                   
                      {selectedOrder.shipping_country}
                      <br />
                      {selectedOrder.shipping_telephone ?  selectedOrder.shipping_telephone : selectedOrder.telephone}
                      <br />

                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={12}>
                <Card className="mb-3">
                  <Card.Header>Order Summary</Card.Header>
                  <Card.Body>
                    {selectedOrder.WebtagOrderTotals.map((total, index) => (
                      <div key={index} className="mb-2">
                        <strong>{total.title}</strong>:{" "}
                        {formatPrice(total.value)}
                      </div>
                    ))}
                    <div className="mt-3">
                      <strong>Total Amount:</strong>{" "}
                      {formatPrice(selectedOrder.total)}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default OrderList;
